<template>
    <div class="wrapper pd-b-60">
        <PersonCover :data="personCover"/>
        <HorizontalScrollListRectangular :data="appearanceMoviesList"/>
    </div>
</template>

<script>
    import axios from "axios";
    import firebase from "firebase";
    import { mapState } from "vuex";
    import PersonCover from "@/components/PersonCover.vue";
    import HorizontalScrollListRectangular from "@/components/HorizontalScrollListRectangular.vue";

    const fb = require('../firebaseConfig.js');
    const increment = firebase.firestore.FieldValue.increment(1);
    
    export default {
        name : 'Person',
        components : {
            PersonCover : PersonCover,
            HorizontalScrollListRectangular : HorizontalScrollListRectangular,
        },
        computed : {
            ...mapState(['userProfile', 'currentUser'])
        },
        data : function () {
            return {
                personDataDbUpload : {},
                personInfo : {},
                personCoverImageBasePath : 'https://image.tmdb.org/t/p/w500',
                movieImgBasePath: "https://image.tmdb.org/t/p/w500",
                personCover : {
                    image : '',
                    title : '',
                    subtitle : '',
                    primaryInfo : [],
                    loaded : false,
                },
                appearanceMoviesList : {
                    title : 'Appearance in movies',
                    list : [],
                }
            }
        },
        methods : {
            fetchPersonData(){
                let key = process.env.VUE_APP_TMDB_APP_KEY;
                let person_id = this.$route.params.person_id;
                fb.personCollection.doc('' + person_id).get()
                .then((doc) => {
                    if (doc.exists) {
                        this.personInfo = Object.assign({}, doc.data())
                        return null;
                    } else {
                        return axios.get(`https://api.themoviedb.org/3/person/${person_id}?api_key=${key}`);
                    }
                })
                .then((response) => {
                    if (response) {
                        this.personDataDbUpload = Object.assign({}, response.data);
                        return axios.get(`https://api.themoviedb.org/3/person/${person_id}/combined_credits?api_key=${key}`);
                    } else {
                        return null;
                    }
                })
                .then((response) => {
                    if (response) {
                        let data = Object.assign({}, response.data);
                        let movie_ids_cast = [];
                        let movie_ids_crew = [];
                        data.cast.forEach((e, i) => {
                            if ((typeof e.media_type !== 'undefined') && (e.media_type === 'movie')) {
                                movie_ids_cast.push(e.id);
                            }
                        });
                        data.crew.forEach((e, i) => {
                            if ((typeof e.media_type !== 'undefined') && (e.media_type === 'movie')) {
                                movie_ids_crew.push(e.id);
                            }
                        });
                        this.personDataDbUpload['movie_ids_cast'] = [...movie_ids_cast];
                        this.personDataDbUpload['movie_ids_crew'] = [...movie_ids_crew];
                        this.personInfo = Object.assign({}, this.personDataDbUpload);
                        return fb.personCollection.doc('' + person_id).set(this.personDataDbUpload)
                    } else {
                        return null;
                    }
                })
                .then((result) => {
                    this.prepareCoverSectionData();
                    this.prepareAppearanceSectionData();
                })
                .catch((err) => {
                    console.error(err.message);
                })
            },
            prepareCoverSectionData(){
                let genderMap = {0:'NA', 1:'Female', 2:'Male'};
                let bd = this.personInfo.profile_path;
                let img = this.personCoverImageBasePath;
                if (bd == null) {
                    bd = '';
                    img = '';
                }
                this.personCover.image = img + bd;
                this.personCover.title = this.personInfo.name;
                this.personCover.subtitle = (this.personInfo.gender == 0 ? '' : (this.personInfo.gender == 1 ? 'Actress' : 'Actor'));
                this.personCover.primaryInfo = [];
                let dob = new Date(this.personInfo.birthday);
                let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                this.personCover.primaryInfo.push({title : 'Born on', subtitle : `${dob.getDate()} ${months[dob.getMonth()]}, ${dob.getFullYear()}`});
                if (this.personInfo.deathday != null) {
                    let dod = new Date(this.personInfo.deathday);
                    this.personCover.primaryInfo.push({title : 'Died on', subtitle : `${dod.getDate()} ${months[dod.getMonth()]}, ${dod.getFullYear()}`});
                }
                this.personCover.primaryInfo.push({title : 'Place of birth', subtitle : (this.personInfo.place_of_birth == null ? 'NA' : this.personInfo.place_of_birth)});
                this.personCover.primaryInfo.forEach((e, i) => {
                    e.id = '_' + Math.random().toString(36).substr(2, 9);
                })
                this.personCover.loaded = true;
            },
            prepareAppearanceSectionData(){
                if (this.personInfo.movie_ids_cast.length == 0) {
                    return;
                }
                let list = [...this.personInfo.movie_ids_cast];
                let randomList = list.sort((val1, val2) => {
                    return 0.5 - Math.random();
                }).slice(0, 20);
                this.appearanceMoviesList['list'] = this.getAppearanceMovies(randomList);
            },
            getAppearanceMovies(list) {
                let key = process.env.VUE_APP_TMDB_APP_KEY;
                let appearanceMoviesList = [];
                let tInterval = 20;
                list.forEach((e, i) => {
                    let movie_id = e;
                    fb.movieCollection.doc('' + movie_id).get()
                    .then((doc) => {
                        if (doc.exists) {
                            return doc.data();
                        } else {
                            return new Promise((resolve, reject) => {
                                setTimeout(() => {
                                    resolve(i);
                                }, i * tInterval);
                            })
                            .then((status) => {
                                return axios.get(`https://api.themoviedb.org/3/movie/${movie_id}?api_key=${key}`);
                            })
                            .then((response) => {
                                let data = Object.assign({}, response.data);
                                data.nepometer = {likes:0, nopes:0};
                                return data;
                            })
                        }
                    })
                    .then((data) => {
                        let item = {};
                        item['id'] = data['id'];
                        item['title'] = data['title'];
                        item['url'] = `/movie/${data.id}`
                        let bd = data['backdrop_path;'] 
                        let image = this.movieImgBasePath
                        if (bd == null) {
                            bd = data['poster_path'];
                            if (bd == null) {
                                bd = '';
                                image = '';
                            }
                        }
                        item['image'] = image + bd;
                        item['ratings'] = this.getNepometerRating(data['nepometer']);
                        item['decision'] = this.setNepometerRating(data['nepometer']);
                        appearanceMoviesList.push(item);
                    })
                    .catch((err) => {
                        console.error(err.message);
                    })
                });
                return appearanceMoviesList;
            },
            getNepometerRating(nepometer) {
                let total = Math.max(1,nepometer.likes + nepometer.nopes);
                let nepoPercentage = 10 * nepometer.likes / total;
                let nepoRating = Math.round(nepoPercentage*10)/10;
                return nepoRating;
            },
            setNepometerRating(nepometer) {
                let total = Math.max(1, nepometer.likes + nepometer.nopes);
                let nepoPercentage = 10 * nepometer.likes / total;
                let nepoRating = Math.round(nepoPercentage*10)/10;
                return (nepoRating > 5) ? 'down' : 'up';
            },
        },
        created() {
            this.fetchPersonData();
        }
    }
</script>

<style>

</style>